import React, { useEffect, useRef, useState } from "react";

import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import googleicon from '../../Assets/Images/googleicon.png';
import stripeicon from '../../Assets/Images/stripeImg.png';
import paymentsuccessIcon from '../../Assets/Images/paymentsuccess.png';
import { formatUSNumber, MakeAxiosRequest } from "../../utils/handler";
import { useForm, Controller } from "react-hook-form";
import { Link, useNavigate, useParams } from 'react-router-dom';
import StripeContainer from './StripeContainer';
import { Modal, Button } from 'react-bootstrap';

function PaymentFinal() {
    const params = useParams();
    const stripe = useStripe();
     const navigate = useNavigate();
    const [processing, setProcessing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [succeeded, setSucceeded] = useState(false);
    const [paymentError, setPaymentError] = useState(null); // Store payment error
    const [showModal, setShowModal] = useState(false); // Toggle modal visibility

// On the return page (e.g., /payment-confirmation)
useEffect(() => {
  const handleFinalPayment = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const paymentIntentClientSecret = urlParams.get('payment_intent_client_secret');

    if (paymentIntentClientSecret) {
      const { error, setupIntent } = await stripe.retrieveSetupIntent(paymentIntentClientSecret);

      if (error) {
        // Show error message and show error popup
        console.log(error.message);
      } else if (setupIntent.status === 'succeeded') {
        // Redirect to success page
        handleSuccess(setupIntent);
      } else {
        // Handle any other statuses as needed
        console.log('Unknown error occurred.');
      }
    }
  };

  handleFinalPayment();
}, []);
const handleSuccess = async(setupIntent) => {
      const key = params.key; // Replace with your actual key
      // After 3D Secure completion or if it's not required, handle the success
      console.log('Payment method attached successfully:', setupIntent);
      // Call the API to save the payment method or trigger the next steps
        const response = await MakeAxiosRequest("post", "/makepayment/"+params.key, {
               payment_method: setupIntent.payment_method,
                invoiceKey: key,
                setupIntentID: setupIntent.id
            });

            if (response.status == 1) {
                 setIsLoading(false);
                 navigate('/payment/success/'+params.key); // Redirect to '/another-page'
            } else {
                
                setPaymentError(response);
                setIsLoading(false);
                setShowModal(true);
                console.error('Unexpected response:', response);
            }
    };
    
}

export default PaymentFinal